/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ReportAddIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Report Add',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M15.084 30H10.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h4.25a12.252 12.252 0 0 1 .334-2H10.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h6.393a12.349 12.349 0 0 1 1.743-2H16.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v6.393a12.269 12.269 0 0 1 2-1.124V6.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v8.25c.331-.027.662-.05 1-.05s.669.024 1 .05V5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h6.769a12.2 12.2 0 0 1-.685-2ZM10 14.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5Z"
    />
    <path
      d="M27.1 18.2a8.9 8.9 0 1 0 8.9 8.9 8.9 8.9 0 0 0-8.9-8.9Zm5 9.4a.5.5 0 0 1-.5.5h-3.5v3.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-3.5h-3.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3.5v-3.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.5h3.5a.5.5 0 0 1 .5.5Z"
    />
  </svg>`;
};
